import React from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Feature } from "@lomarengas/design-system";

const ReportsPageType: Page = {
  ActiveTab: "reports",
  DisplayName: "Raportit",

  LinkUrl: "/reports",
  Path: "/reports",
  RouteName: "reports",
};

const ReportsPage = () => {
  return (
    <div className={ReportsPageType.RouteName}>
      <Layout CurrentPage={ReportsPageType}>
        <PageHeader
          Title={ReportsPageType.DisplayName}
          SubTitle={ReportsPageType.DisplayParentName}
          Back={false}
          Icon="graph-up-arrow"
        ></PageHeader>
        <Row xs={1} sm={2} md={3} xl={4} className="g-24">
          <Col>
            <Feature
              IconName="person"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Omistajaraportti"
            />
          </Col>
          <Col>
            <Feature
              IconName="percent"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Arvonlisäveroerittely"
            />
          </Col>
          <Col>
            <Feature
              IconName="box-arrow-in-right"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Tulijat"
            />
          </Col>
          <Col>
            <Feature
              FullWidth
              IconName="box-arrow-right"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Lähtijät"
            />
          </Col>
          <Col>
            <Feature
              IconName="key"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Huoltoraportti"
            />
          </Col>
          <Col>
            <Feature
              IconName="cash-coin"
              LinkText="Lue lisää"
              LinkUrl="#"
              Text=" Some quick example text to build on the card title and make
                    up the bulk of the card's content."
              Theme="card"
              Title="Tilitysraportti"
            />
          </Col>
        </Row>
      </Layout>
    </div>
  );
};

export default ReportsPage;
